<template>

  <v-container fluid>
<!--    <v-row align="center" justify="space-between" class="dddark rounded mb-5 infocontainer" style="margin-top: -10px;" v-show="noDataAvailable">-->
<!--      <v-col cols="12">-->
<!--        <span class="d-block pb-1 text-h6 text-center">{{$t('components.WebsiteDashboard.NoReviews')}}</span>-->
<!--      </v-col>-->
<!--    </v-row>-->
    <v-row align="start" justify="space-between" class="dddark rounded" style="margin-top: -10px;">
      <v-col cols="auto">
        <span class="d-block pb-1 text-h6">{{ $t('components.WebsiteDashboard.Title') }} {{ this.propertyName }}</span>
      </v-col>
      <v-col cols="auto" v-if="!isMobile">
        <v-btn
            outlined
            elevation="0"
            @click="downloadReport"
            :disabled="loading"
            style="margin-top: 1px; border-color: var(--v-ddgrey-base )">
          <v-icon color="ddgrey">mdi-download</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row id="website_report" class="ddblack">
      <v-col cols="12">
        <WebsitePercentages :websitesData="data.stats" :loading="loading"/>
      </v-col>

      <v-col cols="12" md="6">
        <TotalUsers :websitesData="data.usersByDate" :loading="loading"/>
      </v-col>

      <v-col cols="12" md="6">
        <TotalNewUsers :websitesData="data.newUsersByDate" :loading="loading"/>
      </v-col>

      <v-col cols="12" lg="6">
        <SessionsByChannel :websitesData="data.sessionsByChannelGroup" :loading="loading"/>
      </v-col>

      <v-col cols="12" md="6">
        <EventCountByMonth :websitesData="data.eventCountByMonth" :loading="loading"/>
      </v-col>

      <v-col cols="12" md="6">
        <ViewsByPage :websitesData="data.viewsByPage" :loading="loading"/>
      </v-col>

      <v-col cols="12" md="6">
        <TotalUsersByCountry :locations="data.locations" :loading="loading"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

//import DataAPI from '@/utils/DataAPI';

import WebsitePercentages from "@/components/dashboard/widgets/WebsitesPercentages.vue";
import TotalUsers from '../components/dashboard/widgets/TotalUsers.vue';
import TotalNewUsers from '../components/dashboard/widgets/TotalNewUsers.vue';
import SessionsByChannel from '../components/dashboard/widgets/SessionsByChannel.vue';
import EventCountByMonth from '../components/dashboard/widgets/EventCountByMonth.vue';
import TotalUsersByCountry from '../components/dashboard/widgets/TotalUsersByCountry.vue';
import ViewsByPage from '../components/dashboard/widgets/ViewsByPage.vue';
import WebMDdata from '../utils/WebMDdata.js'
import DataAPI from "@/utils/DataAPI";
import EventBus from "@/utils/EventBus";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export default {
  name: 'WebsitesDashboard',
  props: {
    propertyKey: {
      type: Number,
      required: true
    },
    propertyName: {
      type: String,
      required: true
    }
  },
  data: () => ({
    loading: true,
    data: {
      chats: {},
      existingVsNewOnes: {},
      stats: {},
      questions: {},
      locations: {
        locations: [],
        topLocations: []
      },
      devices: {},
      usersByDate: {},
      newUsersByDate: {},
      sessionsByChannelGroup: {},
      eventCountByMonth: {},
      viewsByPage: {}
    },
    isMobile: false
  }),
  async mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
    await this.updateData();
    console.log("Mounted")
  },
  methods: {
    sortDataWithDateKeys(data) {
      return Object.fromEntries(
          Object.entries(data).sort((a, b) => new Date(a[0]) - new Date(b[0]))
      );
    },
    sortDataByValue(data) {
      return Object.fromEntries(
          Object.entries(data).sort((a, b) => b[1] - a[1])
      );
    },
    async updateData() {
      const data = await DataAPI.getWebMDData(this.propertyKey);
      //const data = this.getWebMDData();
      this.data.stats = data.stats;
      this.data.usersByDate = this.sortDataWithDateKeys(data.total_users_by_month);
      this.data.newUsersByDate = this.sortDataWithDateKeys(data.new_users_by_month);
      this.data.sessionsByChannelGroup = this.sortDataByValue(data.sessions_by_channel_group);
      this.data.eventCountByMonth = this.sortDataWithDateKeys(data.events_by_month);
      this.data.locations.locations = this.sortDataByValue(data.total_users_by_location);
      this.data.viewsByPage = this.sortDataByValue(data.views_by_page);
      this.loading = false;
    },
    onResize() {
      this.isMobile = window.innerWidth < 1000;
    },
    async downloadReport() {
      EventBus.$emit("popup", "Downloading...");
      const reportElement = document.getElementById('website_report');
      const filename = `${this.propertyName}_websites_stats.pdf`;
      const canvas = await html2canvas(reportElement);
      const img = canvas.toDataURL('image/png');
      const doc = new jsPDF({
        unit: 'px',
        format: [canvas.width, canvas.height],
        hotfixes: ["px_scaling"]
      });
      doc.addImage(img, 'PNG', 0, 0);
      doc.save(filename);
    },
    getWebMDData() {
      const data = WebMDdata;
      return data
    }
  },
  components: {
    WebsitePercentages,
    TotalUsers,
    TotalNewUsers,
    ViewsByPage,
    EventCountByMonth,
    SessionsByChannel,
    TotalUsersByCountry
  }
}
</script>